module.exports = __webpack_public_path__ + "media/images/pic/teachers/marta-klimiuk-nikkarinen-b3bb03fbccaa42e8c0f8b3bad9ef37c8.png";